import React, { useRef } from "react";
import SwitchInput from "common/SwitchInputWithState";
import { getFormData, rankAndParseFields } from "./utils";

export const GreSettings = ({ onChange, defaults = {}, state = {} }) => {
  const form = useRef(null);
  const onInputChange = () => {
    const values = getFormData(form.current);
    onChange(rankAndParseFields(values, state));
  };
  return (
    <form ref={form}>
      <h2 className="card-inside-title">Basic GRE Support (no checksum, no key, no sequence)</h2>
      <SwitchInput
        defaultChecked={defaults.gre}
        className={"sw-input"}
        name="gre"
        label="Get IP addresses from inside GRE tunnel"
        onChange={onInputChange}
      />
    </form>
  );
};